var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-exit-layout',{attrs:{"showBottom":false}},[_c('el-container',[_c('el-header',[_c('h3',[_vm._v(_vm._s(_vm.name))])]),_c('el-main',[_vm._v(_vm._s(_vm.content))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }